/* src/app/main/pages/apps/other-apps/other-apps.component.css */
.other-apps .card {
  background-color: #FAFAFA;
  border: none;
  box-shadow: 0px 3px 6px #00000029;
  border-top: 4px solid transparent;
  cursor: pointer;
  margin-bottom: 20px;
}
.other-apps .card:hover {
  border-top: 4px solid #E8882D;
}
.other-apps .card .card-body {
  padding-bottom: 0;
  padding-left: 15px;
  padding-right: 15px;
}
.other-apps .card .card-body .card-text {
  margin-bottom: 30px;
  min-height: 63px;
}
.other-apps .card .btn-details {
  background-color: transparent;
  text-decoration: underline;
  border: none;
  color: #E8882D;
  padding: 8px 30px;
  border-radius: 0px;
}
.other-apps .card .btn-details:hover {
  background-color: #E8882D;
  color: #fff;
}
.other-apps .card:hover .btn-details {
  background-color: #E8882D;
  color: #fff;
}
.other-apps .app-img {
  width: 60px;
  height: 60px;
  margin: 0 auto;
  margin-top: 12px;
  border-radius: 1px;
}
.other-apps .card h5 {
  font-size: 16px;
}
@media (device-width: 1024px) {
  .other-apps .card h5 {
    font-size: 16px;
  }
}
@media (device-width: 768px) {
  .other-apps .card h5 {
    font-size: 20px;
  }
}
@media (max-width: 355px) {
  .other-apps .card h5 {
    font-size: 15px;
  }
}
@media (min-device-width: 1440px) and (max-device-width: 1599px) {
  .other-apps .card h5 {
    font-size: 19px;
  }
  .other-apps h4 {
    font-size: 30px;
  }
}
@media (min-width: 1600px) {
  .other-apps .card h5 {
    font-size: 21px;
  }
  .other-apps h4 {
    font-size: 30px;
  }
  .other-apps .app-img {
    width: 65px;
    height: 65px;
    margin-top: 16px;
  }
  .other-apps .card .btn-details {
    padding: 15px 30px;
    font-size: 20px;
  }
}
/*# sourceMappingURL=other-apps.component.css.map */
